import { defineMessages } from 'react-intl';

export const generalMessages = defineMessages({
  pickDiscount: {
    id: 'checkout.general.pageStep.pickDiscount',
    defaultMessage: 'Pick Discount',
    description: 'Page step text for upselling page',
  },
  enterEmail: {
    id: 'checkout.general.pageStep.enterEmail',
    defaultMessage: 'Enter e-mail',
    description: 'Page step text for enter email page',
  },
  payment: {
    id: 'checkout.general.pageStep.payment',
    defaultMessage: 'Payment',
    description: 'Page step text for payment page',
  },
  deliveryAddress: {
    id: 'checkout.general.pageStep.deliveryAddress',
    defaultMessage: 'Delivery address',
    description: 'Page step text for add delivery address page',
  },
  orderSummary: {
    id: 'checkout.general.pageStep.orderSummary',
    defaultMessage: 'Order Summary',
    description: 'Page step text for order summary page',
  },
  callCenterText: {
    id: 'checkout.general.header.callCenterText',
    defaultMessage: '',
    description: 'Header text is by default empty text - since we dont have any universal message for this',
  },
  callCenterOpenedText: {
    id: 'checkout.general.header.callCenterOpenedText',
    defaultMessage: '',
    description: 'Header text is by default empty text - since we dont have any universal message for this',
  },
  callCenterOpeningHoursText: {
    id: 'checkout.general.header.callCenterOpeningHours',
    defaultMessage: '',
    description: 'Header text is by default empty text - since we dont have any universal message for this',
  },
  free: {
    id: 'checkout.general.freeProduct',
    defaultMessage: 'free',
  },
  pieceUnit: {
    id: 'checkout.general.pieceUnit',
    defaultMessage: 'pc.',
  },
  totalPrice: {
    id: 'checkout.general.totalPrice',
    defaultMessage: 'Total price including VAT:',
    description: 'Text that is being displayed in cart in total price row',
  },

  view: {
    id: 'checkout.general.actions.view',
    defaultMessage: 'View',
  },
});
